import type { MissingFileKeyHelpRequest } from '@/types/fileKey/FileKeyFacilitation';

export abstract class FileKeyFacilitationService {
  abstract getMissingFileKeyRequests(): Promise<MissingFileKeyHelpRequest[]>;
  abstract submitNewFileKey(
    sixId: string,
    fileId: string,
    newFileKeyCreatedForUserId: string,
    newFileKeyCID: string,
  ): Promise<void>;
}
